export default {
  label: 'HTML',
  attrs: [
    {
      attr: '',
      value: ''
    }
  ],
  tag: 'p',
  content: '',
  key: 'html',
  className: '',
  customClass: '', // Class for formways-component wrapper
  hidden: false,
  type: 'htmlelement',
  input: false
};
